import Notifier from 'common/helpers/Notifier';
import { isHttpSuccess } from 'src/api/utils/httpStatus';
import { coreApi } from 'src/api/config';

const onError = (error) => {
  Notifier.handleErrors(error);
  return error;
};

const updateContactPreferences = async (contactPreferencesId, contactPreferences) => {
  try {
    const response = await coreApi.updateRecord('contact_preference', contactPreferencesId, contactPreferences);
    if (!response || !isHttpSuccess(response.status)) {
      return onError(response);
    }
    return response;
  } catch (error) {
    return onError(error);
  }
};

export default updateContactPreferences;
